import type { ReactNode } from 'react'
import { Container } from '@/components/ui/container'

interface PageHeaderProps {
	title: string
	subtitle?: string
	endSlot?: ReactNode
}

export const PageHero = ({ title, subtitle, endSlot }: PageHeaderProps) => {
	return (
		<div className='z-1 grid grid-cols-[1fr_auto] items-start border-neutral-200 border-b bg-neutral-white py-6'>
			<Container fullWidth>
				<div className='flex items-center justify-between'>
					<div className='flex gap-2 max-xl:flex-col xl:items-center'>
						<h1 className='font-bold text-lg text-neutral-900'>
							{title}
						</h1>
						{subtitle && (
							<p className='text-base text-neutral-600'>
								{subtitle}
							</p>
						)}
					</div>
					{endSlot && <div>{endSlot}</div>}
				</div>
			</Container>
		</div>
	)
}

PageHero.displayName = 'PageHero'
